import { FiCheck, FiStar } from "react-icons/fi";
import PlanAction from "./PlanAction";
import PlanCard from "./PlanCard";
import { count, displayCount, isInstitutionPlan, picksPolicy, planDuration, planPrice } from "./subscriptionDetails";

const Included = () => <span className="plans-included"><FiCheck aria-hidden="true" />Included</span>;

export default function PlanComparison({ plans, activePlan, currency, statusUnavailable }) {
	const institutional = isInstitutionPlan(plans[0]);
	const actionProps = { activePlan, currency, statusUnavailable };
	const isCurrent = (plan) => activePlan && String(activePlan.id) === String(plan.id);
	const rows = [
		{
			label: institutional ? "Price per seat" : "Plan price",
			render: (plan) => {
				const price = planPrice(plan, currency);
				const credits = count(plan.credits);
				return <div className="plans-table-price">
					<p className={"plans-price" + (price === null ? " plans-price-unavailable" : "")}>{price ?? "Price unavailable"}</p>
					<p>{institutional ? "per seat · " : ""}full plan duration</p>
					{credits > 0 && <p className="plans-stars"><FiStar aria-hidden="true" />or {credits.toLocaleString()} stars{institutional ? " per seat" : ""}</p>}
				</div>;
			},
		},
		{ label: "Reading access", render: (plan) => planDuration(plan) ?? "Duration shown at checkout" },
		{
			label: institutional ? "Book allocations per student" : "Premium book picks",
			render: (plan) => displayCount(institutional ? plan.max_allocations_per_seat ?? plan.max_number_of_books : plan.max_number_of_books),
		},
		{
			label: institutional ? "Institution picks bank" : "Unlimited free titles",
			render: (plan) => institutional ? picksPolicy(plan) === "unlimited" ? "Unlimited" : `${displayCount(plan.max_number_of_books)} premium picks` : <Included />,
		},
		{ label: "Offline reading in the app", render: () => <Included /> },
	];

	return <>
		<div className="plans-desktop-comparison">
			<div className="plans-table-scroll" role="region" aria-label="Subscription plan comparison. Scroll horizontally to see more plans." tabIndex={0}>
				<table className="plans-table">
					<caption className="sr-only">Compare subscription prices, reading access, and included features</caption>
					<thead><tr>
						<th scope="col" className="plans-feature-heading">Compare plans<span>{institutional ? "For your institution" : "For individual readers"}</span></th>
						{plans.map((plan) => <th scope="col" key={plan.id} className={isCurrent(plan) ? "plans-table-current" : undefined}>
							<span className="plans-category">{institutional ? "Institution" : "Individual"}</span>
							<h3>{plan.name}</h3>
							{isCurrent(plan) && <span className="plans-current-label"><FiCheck aria-hidden="true" />Current plan</span>}
						</th>)}
					</tr></thead>
					<tbody>
						{rows.map(({ label, render }) => <tr key={label}>
							<th scope="row">{label}</th>
							{plans.map((plan) => <td key={plan.id} className={isCurrent(plan) ? "plans-table-current" : undefined}>{render(plan)}</td>)}
						</tr>)}
						<tr className="plans-table-actions"><th scope="row"><span className="sr-only">Choose a plan</span></th>{plans.map((plan) => <td key={plan.id} className={isCurrent(plan) ? "plans-table-current" : undefined}><PlanAction plan={plan} {...actionProps} /></td>)}</tr>
					</tbody>
				</table>
			</div>
			{institutional && <p className="plans-checkout-note">Choose the number of seats at checkout. Total = price per seat × seats.</p>}
		</div>
		<div className="plans-mobile-cards plans-cards">{plans.map((plan) => <PlanCard key={plan.id} plan={plan} {...actionProps} />)}</div>
	</>;
}
